import { defineMessages } from 'react-intl.macro';
import { CHECK_STATE, CheckSourceEnum } from '../constants';

export const checkStateMessages = defineMessages<CHECK_STATE | 'undefined'>({
  undefined: {
    id: 'document.check.state.undefined',
    defaultMessage: 'Nespuštěno',
  },
  [CHECK_STATE.WAITING_FOR_CHECKING]: {
    id: 'document.check.state.WAITING_FOR_CHECKING',
    defaultMessage: 'Čeká na kontrolu',
  },
  [CHECK_STATE.CHECKING]: {
    id: 'document.check.state.CHECKING',
    defaultMessage: 'Kontroluje se',
  },
  [CHECK_STATE.ABORTED]: {
    id: 'document.check.state.ABORTED',
    defaultMessage: 'Neproběhla',
  },
  [CHECK_STATE.FAILED]: {
    id: 'document.check.state.FAILED',
    defaultMessage: 'Proběhla s chybami',
  },
  [CHECK_STATE.PASSED]: {
    id: 'document.check.state.PASSED',
    defaultMessage: 'Proběhla bez chyb',
  },
  [CHECK_STATE.INTERRUPTED]: {
    id: 'document.check.state.INTERRUPTED',
    defaultMessage: 'Přerušeno',
  },
});

export const checkSourceMessages = defineMessages<CheckSourceEnum>({
  ISDMVS: {
    id: 'document.check.source.dmvs',
    defaultMessage: 'IS DMVS',
  },
  ISDTMK: {
    id: 'document.check.source.dtmk',
    defaultMessage: 'IS DTMK',
  },
});
